// import Toxic from "../../images/circleIcons/Toxic.png";
// import Battery from "../../images/circleIcons/Battery.png";

const questionAnswers = [
  {
    title: "MARKET FOR MMR VACCINE",
    question: "Use the following table to graph the demand curve for the MMR vaccine, used to prevent measles, mumps, and rubella.",
    step: 25,
    stepY: 25,
    row: 8,
    col: 13,
    ymax: 200,
    xmax: 325,
    answer: [{x: 200, y: 25}, {x: 125, y: 100}, {x: 50, y: 175}]
  },
  {
    title: "MARKET FOR MMR VACCINE",
    // question: "In the process of dying denim with indigo, chemicals are introduced to enable the dye to set, or stick to the cloth, which pollute nearby waterways when untreated in wastewater. Graph the social cost using the table below.",
    question: "Graph the social value curve using the information in the table below.",
    step: 25,
    stepY: 25,
    row: 8,
    col: 13,
    ymax: 200,
    xmax: 325,
    answer: [{x: 300, y: 25}, {x: 200, y: 125}, {x: 150, y: 175}]
  },
  {
    title: "MARKET FOR MMR VACCINE",
    question: "Now we have added the supply curve, which represents the sellers’ cost/willingness to supply the vaccine at any given price.",
    step: 25,
    stepY: 25,
    row: 8,
    col: 13,
    ymax: 225,
    xmax: 325,
    answer: [{ buy: 50, sell: 50, socialCost: 150, isOptimal: false, }],
  },
  {
    title: "MARKET FOR MMR VACCINE",
    question: "",
    step: 25,
    stepY: 25,
    row: 8,
    col: 13,
    ymax: 225,
    xmax: 325,
    answer: [{ buy: 175, sell: 225, isOptimal: false, }],
  },
  {
    title: "MARKET FOR MMR VACCINE",
    question: "Which of the following is true:",
    step: 25,
    stepY: 25,
    row: 8,
    col: 13,
    ymax: 225,
    xmax: 325,
    options: [
      "The market produces MORE than the socially optimal amount.",
      "The market produces LESS than the socially optimal amount.",
      "The market produces AT the socially optimal amount."
    ],
    answer: 1, //index 1 mean second option
  },
  {
    title: "MARKET FOR MMR VACCINE",
    question: "Select the deadweight loss area on the graph.",
    step: 25,
    stepY: 25,
    row: 8,
    col: 13,
    ymax: 225,
    ymin: -100,
    xmax: 325,
    options: [],
    answer: [1,2], //index 1 mean second option
  },
  {
    title: "MARKET FOR MMR VACCINE",
    question: "",
    step: 25,
    stepY: 25,
    row: 8,
    col: 13,
    ymax: 225,
    ymin: -100,
    xmax: 325,
    options: [],
    answer: [], //index 1 mean second option
  },
  // {
  //   title: "MARKET FOR LITHUM",
  //   question: "During the mining process, toxic chemicals leak into the rivers near the mines.",
  //   subQuestion: "Consider the market for oil. What happens?",
  //   icon: Battery,
  //   answer: "Supply curve shifts left",
  //   graphType: "supply curve",
  //   briefness:
  //     "If oil providers think they can charge a higher price for oil in the near future, they will keep oil in the ground. The supply of oil will decrease, the supply curve will shift to the left, and that will result in movement along the existing demand curve.",
  // },
];

export default questionAnswers;
